import store from '../../store';
import { config } from '../../config';
import { LinkData } from '../../types/response/LinkData';

export const openPdf = async (link: LinkData, downloadAsAttachment = false): Promise<void> => {
    if (!downloadAsAttachment) {
        await openPdfInReservedTab(link);
        return;
    }

    const response = await fetchPdf(link);
    const url = window.URL.createObjectURL(await response.blob());
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = getFileName(response) ?? 'invoice.pdf';
    anchor.click();
    // Free the blob from memory, delayed since revoking before the download starts can cancel it.
    setTimeout(() => window.URL.revokeObjectURL(url), 1000);
};

/** The tab is reserved synchronously, which popup blockers allow when called from a click handler. */
const openPdfInReservedTab = async (link: LinkData): Promise<void> => {
    const tab = window.open('about:blank', '_blank');

    if (tab) tab.opener = null;

    try {
        const response = await fetchPdf(link);
        const url = window.URL.createObjectURL(await response.blob());

        if (tab) tab.location.href = url;
        else window.open(url, '_blank');
    } catch (error) {
        tab?.close();
        throw error;
    }
};

const fetchPdf = async (link: LinkData): Promise<Response> => {
    const { token } = store.getState().session;

    const response = await fetch(`${config.ApiHost}${link.href}`, {
        method: link.method,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    if (!response.ok) throw new Error(response.statusText);

    return response;
};

const getFileName = (response: Response): string | undefined =>
    response.headers.get('Content-Disposition')?.match(/filename="?([^";]+)"?/i)?.[1];
